export default "__VITE_ASSET__DR65H3R6__"